<template>
    <div class="content">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('userCheckup.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="top-box">
            <div class="top-left" @click="showStatusPicker=true">
                {{ status }}<img class="status-icon"  :src="require(`@/assets/theme/${theme}/status/22userCheckup/01arr.svg`)">
            </div>
            <div class="top-left">
                <span @click="showStartDatePopup = true">{{startDate}}</span>~<span @click="showEndDatePopup = true">{{endDate}}</span>
                <img class="status-icon" :src="require(`@/assets/theme/${theme}/status/22userCheckup/02cal.svg`)">
            </div>
        </div>
        <div class="data-box">
            <div class="data-item" v-for="(item,index) in dataList" :key="index" @click="toDesc(item.id)">
                <div class="data-time">{{item.checkupTime}}</div>
                <div class="error-bar" v-if="item.isError"></div>
                <div class="normal-bar" v-if="!item.isError"></div>
                <div class="conclusion" v-if="!item.isError">{{$t('userCheckup.conclusion0')}}</div>
                <div class="conclusion" v-if="item.isError">{{item.errorCount}}{{$t('userCheckup.conclusion1')}}</div>
                <div class="num-text">{{$t('userCheckup.numText0')}}{{item.success}}{{$t('userCheckup.numText1')}}</div>
            </div>
        </div>
        <van-popup v-model="showStatusPicker" round position="bottom">
            <van-picker
                show-toolbar
                :columns="statusColumns"
                :default-index="statusIndex"
                @confirm="onConfirmStatus"
                @cancel="showStatusPicker = false"
            />
        </van-popup>
        <van-popup v-model="showStartDatePopup" round position="bottom">
            <van-datetime-picker
                v-model="startDateChange"
                type="date"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="onConfirmPartStart"
                @cancel="onCancelPartStart"
                :title="$t('setPlanDate.startDate')"
            />
        </van-popup>

        <van-popup v-model="showEndDatePopup" round position="bottom">
            <van-datetime-picker
                v-model="endDateChange"
                type="date"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="onConfirmPartEnd"
                @cancel="onCancelPartEnd"
                :title="$t('setPlanDate.endDate')"
            />
        </van-popup>
    </div>
</template>

<script>

import {getMonthEndDay, getMonthStartDay, getStr, getToday, getTodayNextMonth} from "../../utils/dateUtils";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: '22userCheckup',
    data() {
        return {
            theme: 'light',
            status: this.$t('userCheckup.all'),
            statusIndex: 2,
            statusColumns: [this.$t('userCheckup.normal'), this.$t('userCheckup.error'), this.$t('userCheckup.all')],
            startDate: getMonthStartDay(0),
            endDate: getMonthEndDay(0),
            startDateChange: new Date(getMonthStartDay(0)),
            endDateChange: new Date(getMonthEndDay(0)),
            showStatusPicker: false,
            minDate: new Date(2025,0,1),
            maxDate: new Date(),
            showStartDatePopup: false,
            showEndDatePopup: false,
            dataList: []
        }
    },
    mounted() {
        if (this.$route.query.theme) {
            this.theme = this.$route.query.theme
        }
        this.getUserCheckupList();
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        getUserCheckupList() {
            this.$api.status.getUserCheckupList({
                status: this.statusIndex == 2 ? '' : this.statusIndex,
                startDate: this.startDate,
                endDate: this.endDate
            }).then(res => {
                this.dataList = res.info;
                this.dealData();
            })
        },
        onConfirmStatus(value, index) {
            this.status = value;
            this.statusIndex = index;
            this.showStatusPicker = false
            this.getUserCheckupList();
        },
        onConfirmPartStart(value) {
            this.startDate = getStr(value);
            this.startDateChange = getStr(value);
            this.dealDate();
            this.showStartDatePopup = false;
            this.getUserCheckupList();
        },
        onCancelPartStart() {
            this.showStartDatePopup = false;
            this.startDateChange = this.startDate;
        },
        onConfirmPartEnd(value) {
            this.endDate = getStr(value);
            this.endDateChange = getStr(value);
            this.dealDate();
            this.showEndDatePopup = false;
            this.getUserCheckupList();
        },
        onCancelPartEnd() {
            this.showEndDatePopup = false;
            this.endDateChange = this.endDate;
        },
        dealDate() {
            if (this.startDate > this.endDate) {
                let temp = this.startDate;
                this.startDate = this.endDate;
                this.endDate = temp;
            }
        },
        dealData() {
            for (let i = 0; i < this.dataList.length; i++) {
                let errorCount = 0;
                if (this.dataList[i].isBosError) {
                    errorCount++;
                }
                if (this.dataList[i].isEcgError) {
                    errorCount++;
                }
                if (this.dataList[i].isHrError) {
                    errorCount++;
                }
                if (this.dataList[i].isPressureError) {
                    errorCount++;
                }
                if (this.dataList[i].isRespiratoryRateError) {
                    errorCount++;
                }
                if (this.dataList[i].isTemperatureError) {
                    errorCount++;
                }
                this.dataList[i].errorCount = errorCount;

                let success = 0;
                if (this.dataList[i].bos) {
                    success++;
                }
                if (this.dataList[i].ecgId) {
                    success++;
                }
                if (this.dataList[i].hr) {
                    success++;
                }
                if (this.dataList[i].pressure) {
                    success++;
                }
                if (this.dataList[i].respiratoryRate) {
                    success++;
                }
                if (this.dataList[i].temperature) {
                    success++;
                }
                this.dataList[i].success = success;
            }
        },
        toDesc(id) {
            this.$router.push({
                name: 'checkupDesc',
                query: {
                    id,
                    lang: this.$i18n.locale,
                    theme: this.theme
                }
            })
        }
    }
}
</script>

<style scoped>

.content {
    color: var(--text-color-1);
}

.top-box {
    width: 345px;
    margin: 0px auto 10px;
    display: flex;
    justify-content: space-between;
}

.top-left {
    font-size: 13px;
    display: flex;
    align-items: center;
}

.status-icon {
    width: 13px;
    margin: 4px;
}

.data-item {
    width: 345px;
    height: 68px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 10px auto;
    position: relative;
}

.data-time {
    position: absolute;
    font-size: 15px;
    color: var(--text-color-2);
    top: 10px;
    left: 17px;
}

.error-bar {
    width: 7px;
    height: 7px;
    background: var(--chart-color-3);
    position: absolute;
    left: 19px;
    top: 34px;
    border-radius: 50%;
}

.normal-bar {
    width: 7px;
    height: 7px;
    background: var(--chart-color-1);
    position: absolute;
    left: 19px;
    top: 34px;
    border-radius: 50%;
}

.conclusion {
    font-size: 13px;
    position: absolute;
    left: 33px;
    top: 30px
}

.num-text {
    font-size: 13px;
    color: var(--text-color-3);
    position: absolute;
    left: 33px;
    bottom: 8px;
    width: 300px;
    white-space: nowrap;      /* 强制不换行 */
    overflow: hidden;        /* 隐藏溢出内容 */
    text-overflow: ellipsis; /* 显示省略号 */
}


/deep/ .van-picker {
    background-color: var(--bg-color-2);
    color: var(--text-color-1);
}

/deep/ .van-picker__mask {
    background-image: none;
}

/deep/ .van-picker-column__item {
    color: var(--text-color-1);
}

/deep/ .van-picker__confirm {
    color: var(--chart-color-8);
    font-size: 17px;
}

/deep/ .van-picker__cancel {
    font-size: 17px;
    color: var(--text-color-2);
}
</style>


// WEBPACK FOOTER //
// src/views/status/22userCheckup.vue